import * as React from "react";
import {cx} from "emotion";

import "./delivery-options.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

import {PricingTableModal2} from "./pricing-table-modal-2/pricing-table-modal-2";

export const DeliveryOptions = ({program, method, templateOptions}) => cs(
    ["pricingModal", (_, next) => PricingTableModal2({title: program.programPreferences.linkName + " Pricing", next})],
    ({pricingModal}) => (
        <div className="delivery-options delivery-options-2cv">
            <div className="header">
                <div {...{
                    className: "title",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Delivery Options",
                }}>
                    Delivery Options
                </div>
                <a {...{
                    onClick: () => {
                        if (!templateOptions) {
                            alert("ERROR: No template available");
                            return;
                        }

                        pricingModal.show({templateOptions});
                    },
                    "xd-qa-type": "link",
                    "xd-qa-name": "Pricing Table",
                }}>
                    Pricing Table
                </a>
            </div>

            <div className="methods">
                {methods.map((m) => cs(
                    keyed(m.name),
                    () => {
                        const selected = method.value === m.name;
                        return (
                            <div
                                className={cx("method", {selected})}
                                onClick={() => method.onChange(m.name)}
                            >

                                <i className={"fa fa-" + m.icon} xd-qa-type="icon" xd-qa-name={m.label}/>
                                <div className="label" xd-qa-type="button" xd-qa-name={m.label}>
                                    {m.label}
                                </div>

                                {selected && (
                                    <div className="check">
                                        <i className="fa fa-check-circle" xd-qa-type="icon"
                                           xd-qa-name="Delivery Method Check"/>
                                    </div>
                                )}
                            </div>
                        );
                    }
                ))}
            </div>
        </div>
    ),
);


const methods = [
    {
        name: "mailing",
        label: "Mail",
        icon: "envelope",
    },
    {
        name: "shipping",
        label: "Ship",
        icon: "truck",
    },
];

